(function () {
  const root = document.getElementById('FreskyAssistant');
  if (!root) return;

  const storageKey = 'freskyClosedThisSession';
  const whatsappUrl = root.dataset.whatsappUrl;
  const pageType = root.dataset.pageType || 'page';
  const rootUrl = root.dataset.rootUrl || '/';
  const productTitle = root.dataset.productTitle || '';
  const productHandle = root.dataset.productHandle || '';
  const locale = (root.dataset.locale || 'it').slice(0, 2);
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const messages = root.querySelector('[data-fresky-messages]');
  const formShell = root.querySelector('[data-fresky-form-shell]');
  const requestForm = root.querySelector('#FreskyContactForm');
  const askForm = root.querySelector('[data-fresky-ask]');
  const askInput = askForm ? askForm.querySelector('input') : null;
  const statusNode = root.querySelector('[data-fresky-form-status]');
  let requestInFlight = false;

  root.querySelectorAll('[data-fresky-image]').forEach((image) => {
    const showFallback = () => {
      image.hidden = true;
      image.closest('.fresky__avatar-wrap, .fresky__mini, .fresky__identity-avatar')?.classList.add('fresky-image-fallback');
    };

    image.loading = 'eager';
    image.addEventListener('error', showFallback, { once: true });

    if (image.complete && image.naturalWidth === 0) {
      showFallback();
    }
  });

  const links = {
    box: `${rootUrl}collections/box-estratti`,
    mini: `${rootUrl}products/mini-box-6-estratti`,
    starter: `${rootUrl}products/starter-box`,
    box24: `${rootUrl}products/box-24-estratti`,
    family: `${rootUrl}products/box-48-estratti`,
    contact: `${rootUrl}pages/contact`,
    cart: `${rootUrl}cart`,
  };

  const copyByLocale = {
    it: {
      choose: 'Ti aiuto io. Per quante persone stai acquistando? Vuoi provare Fresco o fare scorta?',
      shipping: 'Le spedizioni Fresco sono refrigerate. Appena ricevi la box, metti subito le bottiglie in frigorifero.',
      duration:
        "Da chiusi, gli estratti Fresco si conservano fino a 90 giorni in frigorifero, secondo la data indicata in etichetta. Dopo l'apertura, consigliamo di consumarli entro 24/48 ore.",
      cart: 'Mi dispiace per il problema. Posso aiutarti oppure metterti subito in contatto con un operatore Fresco su WhatsApp.',
      extractor:
        "Perfetto, Fresco nasce proprio per questo: frutta e verdura pronta da bere, senza usare l'estrattore, senza preparare nulla e senza pulire.",
      price:
        "Capisco. Ti consiglio di scegliere in base all'uso reale: la Mini Box 6 è perfetta per provare, mentre le box più grandi abbassano il prezzo per bottiglia e ti lasciano il frigo pronto più a lungo.",
      freshness:
        'È un dubbio giusto. Le spedizioni Fresco sono refrigerate e i prodotti vanno messi subito in frigorifero alla consegna.',
      payment: 'Sì, il pagamento avviene tramite checkout sicuro. Dopo l’ordine riceverai conferma e aggiornamenti sulla consegna.',
      default:
        'Ti aiuto volentieri. Fresco è pensato per chi vuole frutta e verdura pronta da bere, senza usare l’estrattore, senza preparare nulla e senza pulire.',
      requestSuccess: 'Grazie, abbiamo ricevuto la tua richiesta. Ti risponderemo il prima possibile.',
      requestError: 'Non siamo riusciti a inviare la richiesta. Puoi scriverci direttamente su WhatsApp.',
      consentError: 'Per ricontattarti via email o telefono devi accettare il consenso per questa richiesta.',
      messageError: 'Scrivi un messaggio prima di inviare la richiesta.',
      formIntro: 'Certo. Lasciami la richiesta: la inviamo direttamente al team Fresco.',
      mini: 'Ti consiglio la Mini Box 6 se vuoi provare Fresco senza fare scorta. È la scelta più semplice per iniziare.',
      starter: 'Ti consiglio la Starter Box 12 se vuoi iniziare una routine settimanale senza esagerare.',
      box24: 'Ti consiglio la Box 24 se vuoi più varietà e il frigo pronto più a lungo. È una scelta molto equilibrata.',
      family: 'Ti consiglio la Family Box 48 se acquisti per famiglia, ufficio o consumo costante. È la scelta più conveniente per bottiglia.',
      recommendQuestion: 'Vuoi che ti porti direttamente alla box consigliata?',
      goBox: 'Vai alla box',
      viewBoxes: 'Vedi tutte le box',
      try: 'Provare',
      routineWeek: 'Routine settimana',
      moreVariety: 'Più varietà',
      familyOffice: 'Famiglia o ufficio',
      adviseBox: 'Consigliami una box',
      adviseUse: 'Consigliami in base all’uso',
      request: 'Lascia una richiesta',
      operator: 'Parla con operatore',
      operatorMsg: 'Certo, ti metto subito in contatto con un operatore Fresco su WhatsApp.',
      extractorFollow: 'Vuoi che ti consigli la box migliore per iniziare?',
      priceFollow: 'Vuoi vedere la box più conveniente per te?',
      freshnessFollow: 'Vuoi che ti mostri la box più adatta per iniziare?',
      paymentFollow: 'Vuoi che ti aiuti a completare l’ordine?',
      defaultFollow: 'Vuoi che ti consigli la box più adatta?',
      chooseBox: 'Scegli box',
      goCart: 'Vai al carrello',
      leaveRequest: 'Lascia richiesta',
      sending: 'Invio in corso...',
      cartEmpty: 'Carrello vuoto',
      items: 'articoli',
      detailsUnavailable: 'dettaglio non rilevabile',
    },
    en: {
      choose: 'I can help. How many people are you buying for? Do you want to try Fresco or stock up?',
      shipping: 'Every Fresco shipment is refrigerated. When the box arrives, place the bottles in the fridge right away.',
      duration:
        'Unopened Fresco juices keep up to 90 days in the fridge, according to the date on the label. Once opened, we recommend consuming them within 24/48 hours.',
      cart: 'Sorry about the issue. I can help or connect you with a Fresco operator on WhatsApp.',
      extractor:
        'Exactly. Fresco is made for this: fruit and vegetables ready to drink, with no extractor, no prep and no cleaning.',
      price:
        'I understand. Choose based on real use: Mini Box 6 is ideal to try, while larger boxes lower the price per bottle and keep your fridge ready longer.',
      freshness:
        'That is a fair question. Fresco shipments are refrigerated and the products should go straight into the fridge on delivery.',
      payment: 'Yes. Payment goes through secure checkout. After ordering, you receive confirmation and delivery updates.',
      default:
        'Happy to help. Fresco is designed for people who want fruit and vegetables ready to drink, with no extractor, no prep and no cleaning.',
      requestSuccess: 'Thank you, we received your request. We will reply as soon as possible.',
      requestError: 'We could not send the request. You can write to us directly on WhatsApp.',
      consentError: 'To contact you by email or phone, we need your consent for this request.',
      messageError: 'Please write a message before sending the request.',
      formIntro: 'Sure. Leave your request: we will send it directly to the Fresco team.',
      mini: 'I recommend Mini Box 6 if you want to try Fresco without stocking up. It is the easiest way to start.',
      starter: 'I recommend Starter Box 12 if you want to begin a weekly routine without overdoing it.',
      box24: 'I recommend Box 24 if you want more variety and a fridge ready for longer. It is a very balanced choice.',
      family: 'I recommend Family Box 48 if you buy for family, office or steady use. It has the best price per bottle.',
      recommendQuestion: 'Do you want me to take you straight to the recommended box?',
      goBox: 'Go to the box',
      viewBoxes: 'View all boxes',
      try: 'Try Fresco',
      routineWeek: 'Weekly routine',
      moreVariety: 'More variety',
      familyOffice: 'Family or office',
      adviseBox: 'Recommend a box',
      adviseUse: 'Recommend by use',
      request: 'Leave a request',
      operator: 'Talk to an operator',
      operatorMsg: 'Sure, I’ll connect you with a Fresco operator on WhatsApp.',
      extractorFollow: 'Would you like me to recommend the best box to start?',
      priceFollow: 'Would you like to see the best-value box for you?',
      freshnessFollow: 'Would you like me to show the best box to start with?',
      paymentFollow: 'Would you like help completing your order?',
      defaultFollow: 'Would you like me to recommend the most suitable box?',
      chooseBox: 'Choose box',
      goCart: 'Go to cart',
      leaveRequest: 'Leave request',
      sending: 'Sending...',
      cartEmpty: 'Cart empty',
      items: 'items',
      detailsUnavailable: 'details unavailable',
    },
    es: {
      choose: 'Te ayudo. ¿Para cuántas personas compras? ¿Quieres probar Fresco o hacer reserva?',
      shipping: 'Todos los envíos Fresco son refrigerados. Cuando llegue la caja, pon las botellas en el frigorífico.',
      duration:
        'Cerrados, los extractos Fresco se conservan hasta 90 días en el frigorífico, según la fecha de la etiqueta. Una vez abiertos, recomendamos consumirlos en 24/48 horas.',
      cart: 'Siento el problema. Puedo ayudarte o ponerte en contacto con un operador Fresco por WhatsApp.',
      extractor:
        'Perfecto, Fresco nace para esto: fruta y verdura listas para beber, sin extractor, sin preparar nada y sin limpiar.',
      price:
        'Entiendo. Elige según el uso real: Mini Box 6 es perfecta para probar, mientras que las cajas más grandes reducen el precio por botella y dejan tu frigorífico listo más tiempo.',
      freshness:
        'Es una duda lógica. Los envíos Fresco son refrigerados y los productos deben ponerse en el frigorífico al recibirlos.',
      payment: 'Sí, el pago pasa por checkout seguro. Después del pedido recibirás confirmación y actualizaciones de entrega.',
      default:
        'Te ayudo encantado. Fresco está pensado para quien quiere fruta y verdura listas para beber, sin extractor, sin preparar nada y sin limpiar.',
      requestSuccess: 'Gracias, hemos recibido tu solicitud. Te responderemos lo antes posible.',
      requestError: 'No pudimos enviar la solicitud. Puedes escribirnos directamente por WhatsApp.',
      consentError: 'Para contactarte por email o teléfono necesitamos tu consentimiento para esta solicitud.',
      messageError: 'Escribe un mensaje antes de enviar la solicitud.',
      formIntro: 'Claro. Déjanos la solicitud: la enviaremos directamente al equipo Fresco.',
      mini: 'Te recomiendo Mini Box 6 si quieres probar Fresco sin hacer reserva. Es la forma más sencilla de empezar.',
      starter: 'Te recomiendo Starter Box 12 si quieres empezar una rutina semanal sin exagerar.',
      box24: 'Te recomiendo Box 24 si quieres más variedad y el frigorífico listo durante más tiempo. Es una opción muy equilibrada.',
      family: 'Te recomiendo Family Box 48 si compras para familia, oficina o consumo constante. Es la opción más conveniente por botella.',
      recommendQuestion: '¿Quieres que te lleve directamente a la caja recomendada?',
      goBox: 'Ir a la caja',
      viewBoxes: 'Ver todas las cajas',
      try: 'Probar Fresco',
      routineWeek: 'Rutina semanal',
      moreVariety: 'Más variedad',
      familyOffice: 'Familia u oficina',
      adviseBox: 'Recomiéndame una caja',
      adviseUse: 'Recomendar según uso',
      request: 'Deja una solicitud',
      operator: 'Hablar con operador',
      operatorMsg: 'Claro, te pongo en contacto con un operador Fresco por WhatsApp.',
      extractorFollow: '¿Quieres que te recomiende la mejor caja para empezar?',
      priceFollow: '¿Quieres ver la caja más conveniente para ti?',
      freshnessFollow: '¿Quieres que te muestre la caja más adecuada para empezar?',
      paymentFollow: '¿Quieres que te ayude a completar el pedido?',
      defaultFollow: '¿Quieres que te recomiende la caja más adecuada?',
      chooseBox: 'Elige caja',
      goCart: 'Ir al carrito',
      leaveRequest: 'Deja solicitud',
      sending: 'Enviando...',
      cartEmpty: 'Carrito vacío',
      items: 'artículos',
      detailsUnavailable: 'detalle no disponible',
    },
  };
  const copy = copyByLocale[locale] || copyByLocale.it;

  function setState(state) {
    root.classList.remove('is-hidden', 'is-teaser', 'is-open', 'is-minimized');
    root.classList.add(`is-${state}`);
  }

  function showInitial() {
    if (window.sessionStorage.getItem(storageKey) === '1') {
      setState('minimized');
      return;
    }
    const delayMap = { product: 7000, cart: 5500, index: 9000 };
    const delay = reducedMotion ? 800 : delayMap[pageType] || 9500;
    window.setTimeout(() => {
      if (window.sessionStorage.getItem(storageKey) !== '1' && !root.classList.contains('is-open')) {
        setState('teaser');
      }
    }, delay);
  }

  function openPanel() {
    setState('open');
    scrollMessages();
  }

  function closePanel() {
    window.sessionStorage.setItem(storageKey, '1');
    setState('minimized');
  }

  function scrollMessages() {
    if (!messages) return;
    messages.scrollTop = messages.scrollHeight;
  }

  function addMessage(text, type = 'bot', actions = []) {
    if (!messages) return null;
    const item = document.createElement('div');
    item.className = `fresky__message fresky__message--${type}`;
    const p = document.createElement('p');
    p.textContent = text;
    item.appendChild(p);

    if (actions.length) {
      const actionWrap = document.createElement('div');
      actionWrap.className = 'fresky__inline-actions';
      actions.forEach((action) => {
        const node = action.href ? document.createElement('a') : document.createElement('button');
        node.textContent = action.label;
        if (action.href) {
          node.href = action.href;
          if (action.external) {
            node.target = '_blank';
            node.rel = 'noopener';
          }
        } else {
          node.type = 'button';
          node.addEventListener('click', action.onClick);
        }
        actionWrap.appendChild(node);
      });
      item.appendChild(actionWrap);
    }

    messages.appendChild(item);
    scrollMessages();
    return item;
  }

  function showForm() {
    if (!formShell) return;
    formShell.hidden = false;
    addMessage(copy.formIntro, 'bot');
    const field = formShell.querySelector('[data-fresky-message]');
    if (field) field.focus({ preventScroll: true });
    scrollMessages();
  }

  function recommendBox(kind) {
    const options = {
      mini: {
        text: copy.mini,
        href: links.mini,
      },
      starter: {
        text: copy.starter,
        href: links.starter,
      },
      box24: {
        text: copy.box24,
        href: links.box24,
      },
      family: {
        text: copy.family,
        href: links.family,
      },
    };
    const option = options[kind] || options.starter;
    addMessage(`${option.text} ${copy.recommendQuestion}`, 'bot', [
      { label: copy.goBox, href: option.href },
      { label: copy.viewBoxes, href: links.box },
    ]);
  }

  function handleAction(action) {
    openPanel();
    if (action === 'choose') {
      addMessage(copy.choose, 'bot', [
        { label: copy.try, onClick: () => recommendBox('mini') },
        { label: copy.routineWeek, onClick: () => recommendBox('starter') },
        { label: copy.moreVariety, onClick: () => recommendBox('box24') },
        { label: copy.familyOffice, onClick: () => recommendBox('family') },
      ]);
    }
    if (action === 'shipping') {
      addMessage(copy.shipping, 'bot', [
        { label: copy.adviseBox, onClick: () => handleAction('choose') },
        { label: copy.viewBoxes, href: links.box },
      ]);
    }
    if (action === 'duration') {
      addMessage(copy.duration, 'bot', [
        { label: copy.adviseUse, onClick: () => handleAction('choose') },
      ]);
    }
    if (action === 'cart') {
      addMessage(copy.cart, 'bot', [
        { label: copy.request, onClick: showForm },
        { label: copy.operator, href: whatsappUrl, external: true },
      ]);
    }
    if (action === 'request') showForm();
    if (action === 'operator') {
      addMessage(copy.operatorMsg, 'bot');
      window.open(whatsappUrl, '_blank', 'noopener');
    }
  }

  function answerFreeText(value) {
    const text = value.toLowerCase();
    addMessage(value, 'user');
    if (text.includes('estrattore') || text.includes('extractor') || text.includes('pulire') || text.includes('clean') || text.includes('limpiar') || text.includes('preparare') || text.includes('prepare') || text.includes('preparar')) {
      addMessage(`${copy.extractor} ${copy.extractorFollow}`, 'bot', [
        { label: copy.chooseBox, onClick: () => handleAction('choose') },
      ]);
    } else if (text.includes('costa') || text.includes('prezzo') || text.includes('caro') || text.includes('price') || text.includes('cost') || text.includes('precio') || text.includes('caro')) {
      addMessage(`${copy.price} ${copy.priceFollow}`, 'bot', [
        { label: copy.viewBoxes, href: links.box },
      ]);
    } else if (text.includes('fresc') || text.includes('spedizion') || text.includes('refriger') || text.includes('shipping') || text.includes('envío')) {
      addMessage(`${copy.freshness} ${copy.freshnessFollow}`, 'bot', [
        { label: copy.chooseBox, onClick: () => handleAction('choose') },
      ]);
    } else if (text.includes('pag') || text.includes('pay') || text.includes('pago') || text.includes('sicuro') || text.includes('secure') || text.includes('seguro') || text.includes('checkout')) {
      addMessage(`${copy.payment} ${copy.paymentFollow}`, 'bot', [
        { label: copy.goCart, href: links.cart },
        { label: copy.operator, href: whatsappUrl, external: true },
      ]);
    } else {
      addMessage(`${copy.default} ${copy.defaultFollow}`, 'bot', [
        { label: copy.chooseBox, onClick: () => handleAction('choose') },
        { label: copy.leaveRequest, onClick: showForm },
      ]);
    }
  }

  async function cartSummary() {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!cart.items || !cart.items.length) return copy.cartEmpty;
      const items = cart.items.map((item) => `${item.quantity} × ${item.product_title || item.title}`).join(', ');
      return `${cart.item_count} ${copy.items}: ${items}`;
    } catch {
      return `${root.dataset.cartCount || 0} ${copy.items} (${copy.detailsUnavailable})`;
    }
  }

  function setStatus(text, type) {
    if (!statusNode) return;
    statusNode.textContent = text;
    statusNode.classList.remove('is-error', 'is-success');
    if (type) statusNode.classList.add(`is-${type}`);
  }

  function buildRequestBody(values, cartText) {
    return [
      'Nuova richiesta ricevuta da Fresky.',
      '',
      'Nome cliente:',
      values.name || 'Non indicato',
      '',
      'Email cliente:',
      values.email || 'Non indicata',
      '',
      'Telefono cliente:',
      values.phone || 'Non indicato',
      '',
      'Messaggio:',
      values.message,
      '',
      'Pagina:',
      window.location.href,
      '',
      'Prodotto visualizzato:',
      productTitle ? `${productTitle}${productHandle ? ` (${productHandle})` : ''}` : 'Non rilevabile',
      '',
      'Carrello:',
      cartText,
      '',
      'Data e ora:',
      new Date().toLocaleString('it-IT'),
      '',
      'Fonte:',
      'Fresky Assistant',
    ].join('\n');
  }

  function hasSuccessSignal(response, html) {
    return response.url.includes('contact_posted=true') || html.includes('contact_posted=true') || html.includes('posted_successfully');
  }

  async function submitRequest(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    if (!requestForm) return;
    if (requestInFlight) return;

    const name = (requestForm.querySelector('[data-fresky-name]')?.value || '').trim();
    const email = (requestForm.querySelector('[data-fresky-email]')?.value || '').trim();
    const phone = (requestForm.querySelector('[data-fresky-phone]')?.value || '').trim();
    const messageNode = requestForm.querySelector('[data-fresky-message]');
    const message = (messageNode?.value || '').trim();
    const consent = requestForm.querySelector('[data-fresky-consent]')?.checked || false;
    const submit = requestForm.querySelector('.fresky__submit');

    if (!message) {
      setStatus(copy.messageError, 'error');
      if (messageNode) messageNode.focus();
      return;
    }

    if ((email || phone) && !consent) {
      setStatus(copy.consentError, 'error');
      return;
    }

    const formData = new FormData(requestForm);
    const cartText = await cartSummary();
    formData.set('contact[subject]', 'Nuova richiesta da Fresky');
    formData.set('contact[email]', email || 'fresconaturalshop@gmail.com');
    formData.set('contact[body]', buildRequestBody({ name, email, phone, message }, cartText));

    setStatus(copy.sending, null);
    if (submit) submit.disabled = true;
    requestInFlight = true;

    try {
      const response = await fetch(requestForm.action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      const html = await response.text();

      if (!response.ok || !hasSuccessSignal(response, html)) {
        throw new Error('contact_form_not_confirmed');
      }

      requestForm.reset();
      setStatus(copy.requestSuccess, 'success');
      addMessage(copy.requestSuccess, 'bot');
    } catch (error) {
      setStatus(copy.requestError, 'error');
      addMessage(copy.requestError, 'bot', [
        { label: copy.operator, href: whatsappUrl, external: true },
      ]);
    } finally {
      requestInFlight = false;
      if (submit) submit.disabled = false;
    }
  }

  root.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-fresky-open]');
    const closeButton = event.target.closest('[data-fresky-close]');
    const actionButton = event.target.closest('[data-fresky-action]');
    if (openButton) openPanel();
    if (closeButton) closePanel();
    if (actionButton) handleAction(actionButton.dataset.freskyAction);
  });

  if (askForm && askInput) {
    askForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const value = askInput.value.trim();
      if (!value) return;
      askInput.value = '';
      answerFreeText(value);
    });
  }

  if (requestForm) {
    requestForm.addEventListener('submit', submitRequest, true);
    const submitButton = requestForm.querySelector('.fresky__submit');
    if (submitButton) submitButton.addEventListener('click', submitRequest, true);
  }

  showInitial();
})();
